import { render, staticRenderFns } from "./LedgerStandart.vue?vue&type=template&id=3d75c5b8&"
import script from "./LedgerStandart.vue?vue&type=script&lang=js&"
export * from "./LedgerStandart.vue?vue&type=script&lang=js&"
import style0 from "./LedgerStandart.vue?vue&type=style&index=0&id=3d75c5b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports